import { render, staticRenderFns } from "./stopTaking.vue?vue&type=template&id=774f41ba"
import script from "./stopTaking.vue?vue&type=script&lang=js"
export * from "./stopTaking.vue?vue&type=script&lang=js"
import style0 from "./stopTaking.vue?vue&type=style&index=0&id=774f41ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports